'use strict';

angular.module('ccasignupModule').component('ccaModuleNotFound',  {
    templateUrl: '/Scripts/app/ccaSignUp/SignUpModule/cca-signup-module-not-found.template.html',
    controller: [
    function ($scope) {
}]});